import { CSSProperties, forwardRef, ReactNode } from 'react'

import styles from './Animation.module.scss'

export enum AnimationDirection {
	Forward = `forward`,
	Back = `back`
}

export type AnimationProps = {
	state: `entering` | `entered` | `exiting` | `exited` | `unmounted`
	direction: `${AnimationDirection}`
	children?: ReactNode
	hideNotUnmount?: boolean
}

export const Animation = forwardRef<HTMLDivElement, AnimationProps>((props, ref): JSX.Element => {
	const { state, children } = props
	const cls = [styles.animation]
	if (state === `entering` || state === `exiting`) cls.push(styles.positioned)
	if (state === `exited`) cls.push(styles.exited)

	const style: CSSProperties = {}

	return (
		<div ref={ref} className={cls.join(' ')} style={style}>
			{children}
		</div>
	)
})

Animation.displayName = 'Animation'
